import React, { Component, Fragment } from 'react';
import { Container } from "reactstrap";
import { observer, inject } from 'mobx-react';
import qs from 'query-string';
import DataWrapper from '../../principal/containers/DataWrapper';
import Footer from '../../comum/components/Footer';
import FooterContent from '../../comum/components/FooterContent';
import SimulacaoServicosStore from '../stores/SimulacaoServicosStore';
import SimulacaoServicosViewStore from '../stores/SimulacaoServicosViewStore';
import SimulacaoServicosEmailStore from '../stores/SimulacaoServicosEmailStore';
import SimulacaoServicosFilterStore from '../stores/SimulacaoServicosFilterStore';
import SimulacaoServicosExpStore from '../stores/SimulacaoServicosExpStore';
import SimulacaoServicosImpStore from '../stores/SimulacaoServicosImpStore';
import SimulacaoServicosCabStore from '../stores/SimulacaoServicosCabStore';
import SimulacaoServicosTraStore from '../stores/SimulacaoServicosTraStore';
import SimulacaoServicosRemStore from '../stores/SimulacaoServicosRemStore';
import { E_TIPO_TELA } from '../stores/Enum';
import FiltroServico from '../components/FiltroServico';
import ResultadoSimulacao from '../components/ResultadoSimulacao';
import DetalhesExportacao from '../components/DetalhesExportacao';
import DetalhesImportacao from '../components/DetalhesImportacao';
import DetalhesCabotagem from '../components/DetalhesCabotagem';
import DetalhesTransbordo from '../components/DetalhesTransbordo';
import DetalhesRemocoes from '../components/DetalhesRemocoes';

@inject('store')
@DataWrapper
@observer
export class SimulacaoServicos extends Component {

    constructor(props, context) {
        super(props, context)

        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
        this.loginStore = this.props.store.loginStore;
        this.modalStore = this.props.store.modalStoreCustom;
        this.appStore = this.props.store.appStore;
        
        this.dataStore = new SimulacaoServicosStore();
        this.emailStore = new SimulacaoServicosEmailStore();
        this.viewStore = new SimulacaoServicosViewStore();
        this.filterStore = new SimulacaoServicosFilterStore();
        this.expStore = new SimulacaoServicosExpStore();
        this.impStore = new SimulacaoServicosImpStore();
        this.cabStore = new SimulacaoServicosCabStore();
        this.traStore = new SimulacaoServicosTraStore();
        this.remStore = new SimulacaoServicosRemStore();
        
        this.controllers = { 
            dataStore: this.dataStore, 
            emailStore: this.emailStore,
            viewStore: this.viewStore,
            filterStore: this.filterStore,
            expStore: this.expStore,
            impStore: this.impStore,
            cabStore: this.cabStore,
            traStore: this.traStore,
            remStore: this.remStore,
        };        
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Simulação de Serviços");

        let { voltar } = this.props.location.state || {};
        const { pathname: locationPathname, search: searchPathname } = this.props.location;

        if (typeof voltar == 'string') voltar = { pathname: voltar, search: '' };
        
        const { pathname, search } = voltar || {};

        this.appStore.showVoltarTopBar(!!pathname, pathname, { state: { voltar: { pathname: locationPathname, search: searchPathname } }, search });

        const params = qs.parse(searchPathname);

        this.filterStore.setQuery(params);
    }

    replaceSearchString = (search) => {
        const { history, location } = this.props;
        const newLocation = {
            pathname: location.pathname,
            search: `?${qs.stringify(search)}`
          }
        history.replace(newLocation);
    }

    render() {
        return (
            <Fragment>
                {this.viewStore.tipoTela === E_TIPO_TELA.ResultadoSimulacao ? (
                    <ResultadoSimulacao controllers={this.controllers} />
                ) : (
                    <Container className="agendamento tela-botoes-inclusao-topo" fluid>
                        <FiltroServico controllers={this.controllers} replaceSearchString={this.replaceSearchString} />
                        {this.viewStore.tipoTela === E_TIPO_TELA.Exportacao &&
                            <DetalhesExportacao controllers={this.controllers} />
                        }
                        {this.viewStore.tipoTela === E_TIPO_TELA.Importacao &&
                            <DetalhesImportacao controllers={this.controllers} />
                        }
                        {this.viewStore.tipoTela === E_TIPO_TELA.Cabotagem &&
                            <DetalhesCabotagem controllers={this.controllers} />
                        }
                        {this.viewStore.tipoTela === E_TIPO_TELA.Transbordo &&
                            <DetalhesTransbordo controllers={this.controllers} />
                        }
                        {this.viewStore.tipoTela === E_TIPO_TELA.Remocoes &&
                            <DetalhesRemocoes controllers={this.controllers} />
                        }
                    </Container>
                )}
                <Footer className="justify-content-center">
                    <FooterContent>
                            Wilson, Sons - 2020-2022
                    </FooterContent>
                </Footer>               
            </Fragment>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/simulacao-servicos/telas/SimulacaoServicos.js